import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './hooks/useCart';
import Header     from './components/Header';
import CartDrawer from './components/CartDrawer';
import HomePage   from './pages/HomePage';
import AdminPage  from './admin/AdminPage';

function StoreFront() {
  const [cartOpen, setCartOpen] = useState(false);
  return (
    <>
      <Header onCartOpen={() => setCartOpen(true)} />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
      <HomePage />
    </>
  );
}

export default function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"      element={<StoreFront />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}
